import { Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { interval, Subscription } from 'rxjs';
import { NbToastrService } from '@nebular/theme';
import { environment } from '../../../environments/environment';
import { ViewChildren, QueryList } from '@angular/core';
import { AgmInfoWindow } from '@agm/core';

@Component({
  selector: 'ngx-new-map-view',
  templateUrl: './new-map-view.component.html',
  styleUrls: ['./new-map-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NewMapViewComponent implements OnInit {
  vehicles: any[] = [];
  selectedVehicle: any = '';
  searchText = '';
  mobileNumber !: string;
  isSidebarOpen = true;


  // map defaults
  lat = 21.2514;
  lng = 81.6296;
  zoom = 7;
  mapType: any;
  loading = false;

  // counters
  runningCount = 0;
  idleCount = 0;
  stoppedCount = 0;
  inactiveCount = 0;
  noDataCount = 0;
  totalCount = 0;

  refreshSub!: Subscription;
  vehicleData: any = [];
  mapInstance!: google.maps.Map;
  vehicleSpeedData: any = [];
  last_trip_summary: any = '';
  mmu_summary: any = '';
  displayVehicles: any[] = [];
  @ViewChildren(AgmInfoWindow) infoWindows!: QueryList<AgmInfoWindow>;
  vehicleCount: any;
  stopedCount: any;
  parkedCount: any;
  offlineCount: any;
  otherCount: any;
  selectedStatuses: string[] = [];
  vehicleInfoData: any;
  enableTodayMMUDetais: boolean = true;
  showMenu: boolean = false;
  WrkLctnCount: any;
  isWorkLocationActive: boolean = false;
  selectedWorkLocationStatuses: string[] = [];
  wlMovingCount: number = 0;
  wlIdlingCount: number = 0;
  wlStoppedCount: number = 0;
  wlParkedCount: number = 0;
  wlOfflineCount: number = 0;
  wlOtherCount: number = 0;
  allVehiclesRaw: any[] = [];
  isAlertsViewOpen: boolean = false;
  alertsLoading: boolean = false;
  selectedAlertType: string = 'all';
  latestAlerts: any[] = [];
  alertTypesList: { key: string; label: string }[] = [];
  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private toasterService: NbToastrService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.mobileNumber = params['mobile'];
      if (this.mobileNumber) {
        this.loadVehicles(this.mobileNumber);
      } else {
        this.loadVehicles(localStorage.getItem('MOBILE'));
      }
    });
    // this.refreshSub = interval(60000).subscribe(() => {
    //   if (this.selectedStatuses.length === 0) {
    //     this.loadVehicles(this.mobileNumber || localStorage.getItem('MOBILE'))
    //   }
    // });
    let mobile = this.mobileNumber || localStorage.getItem('MOBILE');
    if (mobile == "8050883053") {
      this.enableTodayMMUDetais = false;
    }
  }
  onMapReady(map: google.maps.Map) {
    this.mapInstance = map;
  }
  reFreshVehicles() {
    this.loadVehicles(localStorage.getItem('MOBILE'));
  }
  toggleMenu() {
    this.showMenu = !this.showMenu;
  }
  @HostListener('document:click', ['$event'])
  onClickOutside(event: any) {
    if (!event.target.closest('.counter')) {
      this.showMenu = false;
    }
  }
  loadVehicles(mobile: any) {
    this.loading = true;
    const url = `${environment.apiBaseUrl}new_map_data?mobile=${mobile}&X-Api-Key=${environment.X_API_KEY}&user_type=Customer&device_token=Web`;

    this.http.get<any>(url).subscribe({
      next: (res: any) => {
        if (res.status == true) {
          this.vehicleData = res?.data?.vehicles;
          this.vehicleCount = res?.data?.counts;
          // counters
          this.runningCount = this.vehicleCount?.MOVING;
          this.idleCount = this.vehicleCount?.IDLING;
          this.stoppedCount = this.vehicleCount?.STOPPED;
          this.parkedCount = this.vehicleCount?.PARKED;
          this.offlineCount = this.vehicleCount?.OFFLINE;
          this.otherCount = this.vehicleCount?.OTHER;
          this.stopedCount = this.vehicleCount?.STOPPED;
          this.WrkLctnCount = this.vehicleCount?.WORKLOCATION;
          this.totalCount = res?.data?.total;
          this.allVehiclesRaw = res?.data?.vehicles || [];
          this.calculateWorkLocationCounts(this.allVehiclesRaw);

          this.vehicles = res.data?.vehicles.map((v: any) => {
            let icon = 'assets/images/all_images/table/yellow/Car.png'; // idle
            if (v?.vehicle_status_color === "#19d345") {
              icon = 'assets/images/all_images/table/green/Car.png'; // running
            } else if (v.vehicle_status_color === '#ec0101') {
              icon = 'assets/images/all_images/table/red/Car.png'; // stopped
            }
            else if (v.vehicle_status_color === '#8e44ad') {
              icon = 'assets/images/all_images/table/purple/Car.png'; // stopped
            }
            else if (v.vehicle_status_color === '#6c757d') {
              icon = 'assets/images/all_images/table/ash/offline.png'; // stopped
            }
            else if (v.vehicle_status_color === '#f3c623') {
              icon = 'assets/images/all_images/table/yellow/Car.png'; // idle
            }
            else if (v.vehicle_status_color === '#007bff') {
              icon = 'assets/images/all_images/table/blue/Car.png'; // idle
            }
            else {
              icon = 'assets/images/all_images/table/yellow/Car.png'; // stopped
            }
            return {
              id: v.device_id,
              imei: v.imei,
              vehicle_number: v.vehicle_number,
              vehicle_type: v.vehicle_type,
              lat: parseFloat(v.latitude),
              lng: parseFloat(v.longitude),
              speed: v.speed,
              servertime: v.servertime,
              color: v.vehicle_status_color,
              icon: icon,
              last_running_time: v.last_running_time,
              device_link_id: v.device_link_id,
              last_location: v.last_location,
              org_id: v.org_id,
              vehicle_name: v?.vehicle_name
            };
          });
          this.displayVehicles = [...this.vehicles];
          const avgLat = this.vehicles.reduce((sum, v) => sum + v.lat, 0) / this.vehicles.length;
          const avgLng = this.vehicles.reduce((sum, v) => sum + v.lng, 0) / this.vehicles.length;
          // this.lat = avgLat;
          // this.lng = avgLng;
          // setTimeout(() => {
          //   this.fitMapToVehicles();
          // }, 0)
          this.loading = false;
          // this.toasterService.info(res?.message, 'Vehicle Data Refreshed', { status: 'info' })
        }
      },
      error: (err) => {
        this.loading = false;
      },
      complete: () => { }
    });
  }

  filteredVehicles() {
    if (!this.searchText) return this.vehicles;
    return this.vehicles.filter(v =>
      v.vehicle_number.toLowerCase().includes(this.searchText.toLowerCase()) ||
      v.vehicle_name.toLowerCase().includes(this.searchText.toLowerCase()),
    );
  }

  selectVehicle(v: any) {
    this.isAlertsViewOpen = false;
    this.latestAlerts = [];
    this.selectedVehicle = v;
    this.lat = v.lat;
    this.lng = v.lng;
    this.zoom = 14;

    // Show only this vehicle on map
    this.displayVehicles = [v];

    // Close other info windows
    this.infoWindows?.forEach(iw => iw.close());
  }
  closeSidebar() {
    this.selectedVehicle = null;
    this.vehicleInfoData = null;
    this.isAlertsViewOpen = false;
    this.displayVehicles = [...this.vehicles];
    this.zoom = 7;
  }

  logOut() {
    this.router.navigate(['/login']);
  }
  ngOnDestroy(): void {
    if (this.refreshSub) {
      this.refreshSub.unsubscribe();
    }
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  calculateWorkLocationCounts(vehicles: any[]) {
    if (!vehicles || !Array.isArray(vehicles)) return;
    const wlVehicles = vehicles.filter((v: any) => v.is_work_location === true || v.is_work_location === 'true' || v.is_work_location === 1 || v.vehicle_status === 'WORKLOCATION');
    this.wlMovingCount = wlVehicles.filter((v: any) => v.vehicle_status === 'MOVING').length;
    this.wlIdlingCount = wlVehicles.filter((v: any) => v.vehicle_status === 'IDLING').length;
    this.wlStoppedCount = wlVehicles.filter((v: any) => v.vehicle_status === 'STOPPED').length;
    this.wlParkedCount = wlVehicles.filter((v: any) => v.vehicle_status === 'PARKED').length;
    this.wlOfflineCount = wlVehicles.filter((v: any) => v.vehicle_status === 'OFFLINE').length;
    this.wlOtherCount = wlVehicles.filter((v: any) => v.vehicle_status === 'OTHER').length;
  }

  selectWorkLocation() {
    this.isWorkLocationActive = true;
    this.selectedWorkLocationStatuses = [];
    this.selectedStatuses = ['WORKLOCATION'];
    this.vehicleTypefilter('WORKLOCATION');
  }

  selectTotal() {
    this.isWorkLocationActive = false;
    this.selectedWorkLocationStatuses = [];
    this.selectedStatuses = [];
    this.vehicleTypefilter('');
  }

  clearAll() {
    this.selectTotal();
  }

  toggleWorkLocationStatus(status: string) {
    const index = this.selectedWorkLocationStatuses.indexOf(status);
    if (index > -1) {
      this.selectedWorkLocationStatuses.splice(index, 1);
    } else {
      this.selectedWorkLocationStatuses.push(status);
    }

    if (this.selectedWorkLocationStatuses.length === 0) {
      this.selectedStatuses = ['WORKLOCATION'];
      this.vehicleTypefilter('WORKLOCATION');
    } else {
      const filterList = ['WORKLOCATION', ...this.selectedWorkLocationStatuses];
      this.selectedStatuses = [...filterList];
      this.vehicleTypefilter(filterList.join(','));
    }
  }

  toggleStatus(status: string) {
    const index = this.selectedStatuses.indexOf(status);
    if (index > -1) {
      this.selectedStatuses.splice(index, 1);
    } else {
      this.selectedStatuses.push(status);
    }
    this.vehicleTypefilter(this.selectedStatuses.join(','));
  }

  vehicleTypefilter(type: string) {
    this.loading = true;
    const statusString = this.selectedStatuses.join(',');
    const url = `${environment.apiBaseUrl}new_map_data?mobile=${localStorage.getItem('MOBILE') || this.mobileNumber}&vehicle_status=${statusString}&X-Api-Key=${environment.X_API_KEY}&user_type=Customer&device_token=Web`;
    this.http.get<any>(url).subscribe(res => {
      if (res.status == true) {
        this.vehicleData = res?.data?.vehicles;
        this.vehicleCount = res?.data?.counts;
        this.runningCount = this.vehicleCount?.MOVING;
        this.idleCount = this.vehicleCount?.IDLING;
        this.stoppedCount = this.vehicleCount?.STOPPED;
        this.parkedCount = this.vehicleCount?.PARKED;
        this.offlineCount = this.vehicleCount?.OFFLINE;
        this.otherCount = this.vehicleCount?.OTHER;
        this.stopedCount = this.vehicleCount?.STOPPED;
        this.WrkLctnCount = this.vehicleCount?.WORKLOCATION;
        this.totalCount = res?.data?.total;
        this.vehicles = res.data?.vehicles.map((v: any) => {
          let icon = 'assets/images/all_images/table/yellow/Car.png'; // idle
          if (v?.vehicle_status_color === "#19d345") {
            icon = 'assets/images/all_images/table/green/Car.png'; // running
          } else if (v.vehicle_status_color === '#ec0101') {
            icon = 'assets/images/all_images/table/red/Car.png'; // stopped
          }
          else if (v.vehicle_status_color === '#8e44ad') {
            icon = 'assets/images/all_images/table/purple/Car.png'; // stopped
          }
          else if (v.vehicle_status_color === '#6c757d') {
            icon = 'assets/images/all_images/table/ash/offline.png'; // stopped
          }
          else if (v.vehicle_status_color === '#f3c623') {
            icon = 'assets/images/all_images/table/yellow/Car.png'; // idle
          }
          else if (v.vehicle_status_color === '#007bff') {
            icon = 'assets/images/all_images/table/blue/Car.png'; // idle
          }
          else {
            icon = 'assets/images/all_images/table/yellow/Car.png'; // stopped
          }
          return {
            id: v.device_id,
            imei: v.imei,
            vehicle_number: v.vehicle_number,
            vehicle_type: v.vehicle_type,
            lat: parseFloat(v.latitude),
            lng: parseFloat(v.longitude),
            speed: v.speed,
            servertime: v.servertime,
            color: v.vehicle_status_color,
            icon: icon,
            last_running_time: v.last_running_time,
            device_link_id: v.device_link_id,
            last_location: v.last_location,
            org_id: v.org_id,
            vehicle_name: v?.vehicle_name
          };
        });
        this.displayVehicles = [...this.vehicles];
        if (this.vehicles.length && this.mapInstance) {
          // this.fitMapToVehicles();
          const bounds = new google.maps.LatLngBounds();
          this.vehicles.forEach(v => {
            if (v.lat && v.lng) {
              bounds.extend(new google.maps.LatLng(v.lat, v.lng));
            }
          });
          this.mapInstance.fitBounds(bounds);
        }
      }
      this.loading = false;
    });
  }
  vehicleInfo(type: any) {
    this.loading = true;
    this.vehicleInfoData = null;
    const url = `${environment.apiBaseUrl}map_view_device?device_id=${type.id}&X-Api-Key=${environment.X_API_KEY}&device_token=Web`;
    this.http.get<any>(url).subscribe({
      next: (res) => {
        if (res.status == true) {
          this.vehicleInfoData = res?.data;
          if (typeof this.vehicleInfoData?.alert_data === 'string') {
            try {
              this.vehicleInfoData.alert_data = JSON.parse(this.vehicleInfoData.alert_data);
            } catch (e) { }
          }
          this.loading = false;
          // this.toasterService.show(res?.message, 'Vehicle Info', { status: 'success' });
        }
      },
      error: (err) => {
        this.loading = false;
      },
    });

  }

  getAlertDataEntries(data: any): { key: string, value: any }[] {
    if (!data) return [];
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return [];
      }
    }
    if (typeof data === 'object' && data !== null) {
      return Object.keys(data).map(key => ({ key, value: data[key] }));
    }
    return [];
  }

  toggleAlertsView() {
    this.isAlertsViewOpen = !this.isAlertsViewOpen;
    if (this.isAlertsViewOpen) {
      this.fetchLatestAlerts();
    }
  }

  refreshAlerts() {
    this.fetchLatestAlerts();
  }

  onAlertTypeChange(value: string) {
    this.selectedAlertType = value;
    this.fetchLatestAlerts();
  }

  trackByAlertKey(index: number, item: any): string {
    return item ? item.key : index.toString();
  }

  fetchLatestAlerts() {
    this.alertsLoading = true;
    const deviceId = this.selectedVehicle?.id || this.vehicleInfoData?.device_id;
    let url = `${environment.apiBaseUrl}ipulse_latest_alerts?X-Api-Key=${environment.X_API_KEY}&device_token=Web`;
    if (deviceId) {
      url += `&device_id=${deviceId}`;
    }
    if (this.selectedAlertType && this.selectedAlertType !== 'all') {
      url += `&alert_type=${this.selectedAlertType}`;
    }
    this.http.get<any>(url).subscribe({
      next: (res) => {
        this.alertsLoading = false;
        if (res && res.alert_types && Array.isArray(res.alert_types) && res.alert_types.length > 0) {
          const isDifferent = this.alertTypesList.length !== res.alert_types.length ||
            res.alert_types.some((t: any, i: number) => !this.alertTypesList[i] || this.alertTypesList[i].key !== t.key);
          if (isDifferent) {
            this.alertTypesList = res.alert_types;
          }
        }
        if (res && res.data) {
          this.latestAlerts = (res.data || []).map((alert: any) => {
            if (typeof alert.alert_data === 'string') {
              try {
                alert.alert_data = JSON.parse(alert.alert_data);
              } catch (e) { }
            }
            return alert;
          });
        } else {
          this.latestAlerts = [];
        }
      },
      error: (err) => {
        this.alertsLoading = false;
        this.latestAlerts = [];
      }
    });
  }

  focusAlertOnMap(alert: any) {
    if (alert.latitude && alert.longitude) {
      this.lat = parseFloat(alert.latitude);
      this.lng = parseFloat(alert.longitude);
      this.zoom = 16;
    }
  }
  openFullscreen(elem: HTMLElement) {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if ((elem as any).webkitRequestFullscreen) { // Safari
      (elem as any).webkitRequestFullscreen();
    } else if ((elem as any).msRequestFullscreen) { // IE11
      (elem as any).msRequestFullscreen();
    }
  }
  toggleFullscreen(elem: HTMLElement) {
    if (!document.fullscreenElement) {
      elem.requestFullscreen();
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  }
  goHome() {
    this.router.navigate(['/web/newdashboard']);
  }
  openTrackHistory(v: any) {
    if (!v) return;

    // Current date 01:00 AM → current date 23:59:59
    const start = new Date();
    start.setHours(1, 0, 0, 0);
    const end = new Date();
    end.setHours(23, 59, 59, 0);

    const pad = (n: number) => n.toString().padStart(2, '0');
    const fmt = (d: Date) =>
      `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;

    this.router.navigate(
      ['/web/track_history', v.device_link_id],
      {
        queryParams: {
          fromNewMap: true,
          from_date: fmt(start),
          to_date: fmt(end),
          vehicle_name: v.vehicle_name
        }
      }
    );
  }
  openDistanceReport() {
    this.router.navigate(['web/reports_charts/distance-report'],
      {
        queryParams: { fromNewMap: true }
      }
    );
  }
  openVehicleWiseDistanceReport() {
    this.router.navigate(['web/reports_charts/Vehicle-wise-distance-report'],
      {
        queryParams: { fromNewMap: true }
      }
    );
  }
  openKilometerSummary() {
    this.router.navigate(['web/reports_charts/kilometer-summary-management'],
      {
        queryParams: { fromNewMap: true }
      }
    );
  }
  openAlertsReport() {
    this.router.navigate(['web/reports_charts/alerts-report'],
      {
        queryParams: { fromNewMap: true }
      }
    );
  }
  fitMapToVehicles() {
    if (!this.mapInstance || !this.vehicles.length) return;

    const bounds = new google.maps.LatLngBounds();

    this.vehicles.forEach(v => {
      if (!isNaN(v.lat) && !isNaN(v.lng)) {
        bounds.extend(new google.maps.LatLng(v.lat, v.lng));
      }
    });

    this.mapInstance.fitBounds(bounds);

    // Prevent excessive zoom when only one vehicle exists
    google.maps.event.addListenerOnce(this.mapInstance, 'bounds_changed', () => {
      if (this.mapInstance.getZoom()! > 15) {
        this.mapInstance.setZoom(15);
      }
    });
  }
}
